export interface DataEntity_Main_02_Interface {
  id:number,
  calibration_id:number,
  filename:string,
  pdf_src:string,
  delivery_time:Number,
  manufacture:string,
  model:string,
  type:string,
  capability: string,

  unit_nomimal: string,
  unit_reference: string,
  unit_correction: string,
  unit_correction_eqution: string,
  unit_uncertainy: string,
  unit_zfactor: string,
}

export function Empty_DataEntity_Main_02_Interface():DataEntity_Main_02_Interface{
    return{
        id:0,
        calibration_id:0,
        filename:'',
        pdf_src:'',
        delivery_time: 0,
        manufacture:'',
        model:'',
        type:'',
        capability: '',

        unit_nomimal: '',
        unit_reference: '',
        unit_correction: '',
        unit_correction_eqution: '',
        unit_uncertainy: '',
        unit_zfactor: '',
    }
  }
